import { Component } from 'react';
import PropTypes from 'prop-types';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import { assertPropsDefined } from '../utils/PropValidationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default class IndexTableRowHoverCell extends Component {
  render() {
    const {
      buttons,
      content
    } = this.props;
    assertPropsDefined({
      content,
      buttons
    });
    return /*#__PURE__*/_jsx(TableHoverCell, {
      "data-test-id": "table-row-cell-hover",
      hoverContent: buttons,
      tooltip: false,
      children: content
    });
  }
}
IndexTableRowHoverCell.propTypes = {
  content: PropTypes.node.isRequired,
  buttons: PropTypes.node.isRequired
};